export default __webpack_public_path__ + "static/media/go2016F.d147c105.png";